//@flow
import { HiverAxios, showMessage } from 'h-commons';
import {
  MAKE_OR_REMOVE_ADMIN_FAILED,
  MAKE_OR_REMOVE_ADMIN_INIT,
  MAKE_OR_REMOVE_ADMIN_DONE
} from './types';

export function makeOrRemoveAdmin(currentUserId: string | number, ids: Array<string | number>, action: boolean, done: Function) {
  return (dispatch: Function) => {
    dispatch({
      type: MAKE_OR_REMOVE_ADMIN_INIT
    });
    HiverAxios({
      url: `/api/settings/users/changerole/${action ? 'admin' : 'nonadmin'}`,
      type: 'POST',
      params: {
        userIds: ids
      },
      callback: (response) => {
        if (response.data) {
          dispatch({
            type: MAKE_OR_REMOVE_ADMIN_DONE,
            payload: { ids, isAdmin: action }
          });
          const noun = `User${ids.length > 1 ? 's' : ''}`;
          const message = `${noun} role updated `;
          showMessage({
            message,
            type: 'success'
          })
          done();
        } else {
          dispatch({
            type: MAKE_OR_REMOVE_ADMIN_FAILED
          });
          showMessage({
            message: 'User role change failed. Something broke.😞  Try again. If it still does not work, get in touch with Hiver customer support.',
            type: 'error'
          });
        }
      },
      onfail: () => {
        dispatch({
          type: MAKE_OR_REMOVE_ADMIN_FAILED
        });
        showMessage({
          message: 'User role change failed. Something broke.😞  Try again. If it still does not work, get in touch with Hiver customer support.',
          type: 'error'
        });
      }
    })
  };
}
